import { useRef, useEffect } from "react";

/**
 * UseUnload mounts a listener to the browser close function which will trigger a
 * callback function to warn user of unsaved changes etc before closing.
 * @param callbackFunction - see details in link provided for use of callback if blocking close is desired - https://www.tabnine.com/code/javascript/functions/builtins/BeforeUnloadEvent/preventDefault
 * @param triggerCallback - boolean value that determines whether useUnload listener is active or not.
 */
export const useUnload = (callbackFunction: (ev: BeforeUnloadEvent) => void, triggerCallback: boolean): void => {
  const cb = useRef(callbackFunction);
  useEffect(() => {
    const onUnload = cb.current;
    if (triggerCallback) {
      window.addEventListener("beforeunload", onUnload);
    } else if (onUnload) {
      window.removeEventListener("beforeunload", onUnload);
    }
    return () => {
      window.removeEventListener("beforeunload", onUnload);
    };
  }, [cb, triggerCallback]);
};
